import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';

const apiUrl = process.env.REACT_APP_API_URL;
const apiKey = process.env.REACT_APP_API_KEY;
const headers_obj = {
    headers: {
        'ZCFKEY': apiKey
    }
}
export const fetchzcql = async (sql) => {
    try {
        const res = await axios.post(`${apiUrl}zcql`, {
            sql: sql
        }, {
            headers: { Accept: 'application/json', 'ZCFKEY': apiKey }
        });
        return res.data;
    } catch (error) {
        console.error('Error creating zcql:', error);
        return null;
    }
};

function PaymentSuccessModule() {
    const { paymentId } = useParams();
    const navigate = useNavigate();

    const [booking, setBooking] = useState(null);
    const [timeSlot, setTimeSlot] = useState("");
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const getFullDetails = async () => {
            try {
                setLoading(true);
                const response = await fetch(`${apiUrl}booking/${paymentId}`, headers_obj);
                const result = await response.json();

                if (result.success && result.data) {
                    const bookingData = result.data;
                    setBooking(bookingData);

                    if (bookingData.time_slot_id) {
                        const sql = `SELECT label FROM time_slots WHERE ROWID = '${bookingData.time_slot_id}'`;
                        const zcqlRes = await fetchzcql(sql);

                        if (zcqlRes && zcqlRes.success && zcqlRes.response && zcqlRes.response.length > 0) {
                            setTimeSlot(zcqlRes.response[0]['time_slots']['label']);
                        }
                    }
                } else {
                    setError(result.message || 'Booking details not found');
                }
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        if (paymentId) getFullDetails();
    }, [paymentId]);

    const handleBackToDashboard = () => {
        navigate('/app/#/customer');
    };

    if (loading) return (
        <div style={styles.centerContainer}>
            <div style={styles.loaderSpinner}></div>
            <p style={{ color: '#72398E', fontWeight: '600' }}>Processing Payment...</p>
        </div>
    );

    if (error) return (
        <div style={styles.centerContainer}>
            <div style={{ fontSize: '40px' }}>⚠️</div>
            <p style={{ color: '#4A5568', margin: '15px 0' }}>{error}</p>
            <button style={styles.primaryButton} onClick={handleBackToDashboard}>Return to Dashboard</button>
        </div>
    );

    return (
        <div style={styles.page}>
            <div style={styles.container}>
                <div style={styles.header}>
                    <div style={styles.iconCircle}>
                        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                            <polyline points="20 6 9 17 4 12"></polyline>
                        </svg>
                    </div>
                    <h1 style={styles.title}>Payment Received</h1>

                    {/* Conditional Rendering for Transaction ID */}
                    {paymentId && (
                        <p style={styles.orderId}>TRANSACTION ID: {paymentId}</p>
                    )}

                    <p style={styles.orderId}>BOOKING ID: {booking?.ROWID}</p>
                </div>

                <div style={styles.cardBody}>
                    {/* Customer Info */}
                    <div style={styles.section}>
                        <span style={styles.miniLabel}>RESERVED FOR</span>
                        <div style={styles.infoValue}>{booking?.customer_name}</div>
                        <div style={styles.emailText}>{booking?.customer_email}</div>
                    </div>

                    <div style={styles.divider} />

                    {/* Event & Date */}
                    <div style={styles.infoGrid}>
                        <div>
                            <span style={styles.miniLabel}>EVENT</span>
                            <div style={styles.infoValue}>{booking?.eventType}</div>
                        </div>
                        <div style={{ textAlign: 'right' }}>
                            <span style={styles.miniLabel}>DATE</span>
                            <div style={styles.infoValue}>
                                {booking?.booking_date ? new Date(booking.booking_date).toLocaleDateString('en-GB', {
                                    day: 'numeric', month: 'short', year: 'numeric'
                                }) : 'N/A'}
                            </div>
                        </div>
                    </div>

                    {/* Time Slot Highlight */}
                    <div style={styles.timeSlotBox}>
                        <span style={styles.miniLabel}>TIME SLOT</span>
                        <div style={{ ...styles.infoValue, color: '#72398E' }}>{timeSlot || "Confirmed Slot"}</div>
                    </div>

                    <div style={styles.statusBox}>
                        <div style={styles.statusTitle}>Successfully Secured</div>
                        <p style={styles.statusSubtitle}>Your transaction was successful.</p>
                    </div>
                </div>

                <button style={styles.primaryButton} onClick={handleBackToDashboard}>
                    Back to Home
                </button>
            </div>
        </div>
    );
}

const styles = {
    page: { backgroundColor: '#F8F5F9', minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'sans-serif', padding: '20px' },
    container: { width: '100%', maxWidth: '380px' },
    header: {
        background: 'linear-gradient(135deg, #72398E 0%, #4D2163 100%)',
        padding: '30px 20px', borderRadius: '24px 24px 0 0', textAlign: 'center', color: '#FFF'
    },
    iconCircle: { width: '48px', height: '48px', backgroundColor: 'rgba(255, 255, 255, 0.2)', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 12px' },
    title: { fontSize: '20px', fontWeight: '700', margin: 0 },
    orderId: { fontSize: '9px', opacity: 0.8, marginTop: '4px', letterSpacing: '0.5px', textTransform: 'uppercase' },
    cardBody: {
        backgroundColor: '#FFF', padding: '25px', borderRadius: '0 0 24px 24px', boxShadow: '0 10px 25px rgba(0, 0, 0, 0.05)', marginBottom: '20px'
    },
    section: { marginBottom: '15px' },
    emailText: { fontSize: '13px', color: '#718096', marginTop: '2px', fontWeight: '400' },
    infoGrid: { display: 'flex', justifyContent: 'space-between', marginBottom: '15px' },
    timeSlotBox: {
        marginTop: '15px', padding: '12px', backgroundColor: '#F9F5FB', borderRadius: '10px', border: '1px solid #F0E6F5'
    },
    miniLabel: { fontSize: '9px', fontWeight: '800', color: '#A0AEC0', letterSpacing: '0.8px', marginBottom: '4px', textTransform: 'uppercase' },
    infoValue: { fontSize: '15px', fontWeight: '700', color: '#2D3748' },
    divider: { height: '1px', backgroundColor: '#EDF2F7', margin: '15px 0' },
    statusBox: { textAlign: 'center', marginTop: '25px' },
    statusTitle: { fontSize: '16px', fontWeight: '700', color: '#72398E' },
    statusSubtitle: { fontSize: '12px', color: '#718096', marginTop: '4px' },
    primaryButton: {
        width: '100%', padding: '16px', backgroundColor: '#72398E', color: '#FFF', border: 'none', borderRadius: '16px', fontSize: '15px', fontWeight: '700', cursor: 'pointer'
    },
    centerContainer: { display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh' },
    loaderSpinner: { width: '30px', height: '30px', border: '3px solid #F3EBF7', borderTop: '3px solid #72398E', borderRadius: '50%', marginBottom: '10px' }
};

export default PaymentSuccessModule;